var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 13.5C8 9.91015 10.9101 7 14.5 7C18.0899 7 21 9.91015 21 13.5C21 17.0899 18.0899 20 14.5 20C10.9101 20 8 17.0899 8 13.5ZM14.5 6C10.3579 6 7 9.35786 7 13.5C7 17.6421 10.3579 21 14.5 21C18.6421 21 22 17.6421 22 13.5C22 9.35786 18.6421 6 14.5 6ZM15 9.5C15 9.22386 14.7761 9 14.5 9C14.2239 9 14 9.22386 14 9.5V13.5C14 13.7761 14.2239 14 14.5 14H18.5C18.7761 14 19 13.7761 19 13.5C19 13.2239 18.7761 13 18.5 13H15V9.5Z",
  fill: "currentColor"
})));
export default SvgClock28;